import ModalView from '@/components/modals/Modal';
import Container from '@/components/molecules/section/Container';
import Grid, { GridAction, itemText } from '@/components/molecules/section/Grid';
import { Client } from '@/types/client';
import { Modal } from '@/types/modal';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const GetPaid: React.FC<{ client: Client }> = ({ client }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState<Modal | null>(null);
  const { customerGetPaid } = client;

  if (!customerGetPaid) {
    return null;
  }

  const {
    accountState,
    transferMethodState,
    accountType,
    bankName,
    accountDetail,
    kycStatus,
    isPayoutBlocked,
    payoutBlockedReason,
    accountCurrency,
  } = customerGetPaid;

  const actions: GridAction[] = [
    {
      kind: 'Button',
      label: t('client.get_paid.manual_verification').toUpperCase(),
      onClick: () =>
        setModal({
          kind: 'GetPaidManualVerification',
          client,
          onClose: () => setModal(null),
        }),
    },
  ];

  const items = [
    itemText(t('client.get_paid.onboard_acc_state'), accountState),
    itemText(t('client.get_paid.onboard_transfer_state'), transferMethodState),
    itemText(t('client.get_paid.account_type'), accountType),
    itemText(t('client.get_paid.bank_name'), bankName),
    itemText(t('client.get_paid.account_number'), accountDetail),
    itemText(t('client.get_paid.payout_currency'), accountCurrency),
    itemText(t('client.get_paid.kyc_status'), kycStatus),
    itemText(
      t('client.get_paid.payout_blocked'),
      isPayoutBlocked ? t('client.get_paid.yes') : t('client.get_paid.no'),
      undefined,
      undefined,
      isPayoutBlocked ? 'red' : undefined,
    ),
    itemText(t('client.get_paid.payout_blocked_reason'), payoutBlockedReason),
  ];

  return (
    <>
      <Container
        title={t('client.get_paid.title')}
        actions={actions}
        testId="get_paid"
      >
        <Grid
          column={5}
          items={items}
        />
      </Container>

      <ModalView modal={modal} />
    </>
  );
};

export default GetPaid;
